import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const formatDate = (date?: Date): string => {
  return date ? dayjs(date).format('YYYY-MM-DD, HH:mm:ss') : '';
};

export const formatDateUtc = (date?: Date): string => {
  return date ? dayjs(date).utc().format('YYYY-MM-DD, HH:mm:ss') : '';
};
